import axios from "axios";
import { endpoints } from "../_config";

class MixpanelService {
  /**
   * Get all Mix Panel Data
   * @param {*} Bearer token
   * @returns
   */
  static async getMixpanelData(user) {
    return axios
      .get(endpoints.mixpanel.getAllData, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Mixpanel Kpi data Api
   * @param {}
   * @returns
   */
  static async getKpiData(user, data) {
    return axios
      .post(endpoints.mixpanel.getKpiData, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Mixpanel Profile Property data Api
   * @param {}
   * @returns
   */
  static async getProfilePropertyData(user, data) {
    return axios
      .post(endpoints.mixpanel.getProfilePropertyData, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Mixpanel Graph data Api
   * @param {}
   * @returns
   */
  static async getGraphData(user, data) {
    return axios
      .post(endpoints.mixpanel.getGraphData, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Mixpanel Event Property data Api
   * @param {}
   * @returns
   */
  static async getEventPropertyData(user, data) {
    return axios
      .post(endpoints.mixpanel.getEventPropertyData, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { MixpanelService };
